import { render } from "./TenantItem.vue?vue&type=template&id=199b3286&scoped=true"
import script from "./TenantItem.vue?vue&type=script&lang=js"
export * from "./TenantItem.vue?vue&type=script&lang=js"

import "./TenantItem.vue?vue&type=style&index=0&id=199b3286&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199b3286"]])

export default __exports__